export default __webpack_public_path__ + "static/media/intercom.e8f55fa8.svg";